import { createFileRoute } from "@tanstack/react-router";
import Implementation from "@/pages/Implementation";
import { pageHead } from "@/lib/seo";

export const Route = createFileRoute("/th/implementation")({
  head: () => pageHead("/implementation", "th"),
  component: Implementation,
});
